import { ClusteringParams, NeighborhoodClustersFormValues, SamplingParams } from './types';

export const defaultSamplingParams: SamplingParams = {
  absoluteMaxCellsPerSlide: 5000,
  maxCellsFractionPerSlide: 0.25,
  cellClassesToExclude: null,
  weightedSamplingOfCellClasses: true,
  balancedSamplingOfCellClasses: false,
};

export const defaultClusteringParams: ClusteringParams = {
  kMeansParams: {
    minK: 3,
    maxK: 10,
  },
  neighborCountParams: {
    nNeighbors: 10,
    normalizeCounts: true,
    arcsinhNormalizationCoFactor: 5,
    addSelfCellToNeighborCounts: false,
  },
};

export const minMinK = 3;
export const maxMaxK = 20;

export const defaultValues: NeighborhoodClustersFormValues = {
  jobName: '',
  jobDescription: '',
  configParams: {
    cellTableArtifactUrls: [],
    clusteringParams: [defaultClusteringParams],
    samplingParams: defaultSamplingParams,
  },
};
